module.exports = __webpack_public_path__ + "static/index/img/ios.b4a36211.svg";